import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import RuleState from 'app/stores/interface/RuleState';
import { observable } from 'mobx';
export let RuleTestState = (_class = class RuleTestState extends RuleState {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "totalPercentClassified", _descriptor, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "totalPercentClassified", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _class);